class ApplicationEntity {
    constructor(
        userId = '',
        tenant = '',
        sessionId = '',
        imageUrl = '',
        selectedContentId = '',
        serviceAddress = {},
        tenantUniqueId = ''
    ) {
        this.userId = userId;
        this.tenant = tenant;
        this.sessionId = sessionId;
        this.imageUrl = imageUrl;
        this.selectedContentId = selectedContentId;
        this.serviceAddress = serviceAddress;
        this.tenantUniqueId = tenantUniqueId;
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new ApplicationEntity();
        }

        return this.instance;
    }
}

export default ApplicationEntity;

